/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlNotificationEscalationSeverity } from './ControlNotificationEscalationSeverity';
import {
    ControlNotificationEscalationSeverityFromJSON,
    ControlNotificationEscalationSeverityFromJSONTyped,
    ControlNotificationEscalationSeverityToJSON,
} from './ControlNotificationEscalationSeverity';
import type { ControlSku } from './ControlSku';
import {
    ControlSkuFromJSON,
    ControlSkuFromJSONTyped,
    ControlSkuToJSON,
} from './ControlSku';

/**
 * 
 * @export
 * @interface ControlTeam
 */
export interface ControlTeam {
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    address?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    autoSubscribeServiceProviderUsers: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlTeam
     */
    billableEndpoints?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeam
     */
    billableUsers?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    billingEndpointLicenseId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    billingUserLicenseId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    chatOpsAccountLockedMessage: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    chatOpsAccountLockedMessageInherited?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    chatOpsAllowBulkSmsInvite?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlTeam
     */
    chatOpsEscalationDelayMinutes: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    chatOpsSecondFactor: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    chatOpsSubjectLine: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    chatOpsSubjectLineInherited?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    chatOpsWelcomeMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    chatOpsWelcomeMessageInherited?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    demo: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    emailSignature: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    emailSignatureInherited?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    endpointAutoContainment: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlTeam
     */
    escalationEmails: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    escalationSubjectLine?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    fileAutoContainment: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    identityAutoContainment: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    isTrial: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    logoUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    managerChatOps: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlTeam
     */
    maxAutoContainmentsPerDay?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlTeam
     */
    maxChatOpsPerDay?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    name: string;
    /**
     * 
     * @type {ControlNotificationEscalationSeverity}
     * @memberof ControlTeam
     */
    notificationEscalationSeverity: ControlNotificationEscalationSeverity;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    onboardingChecklistCompleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    operatingTeam?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    parentServiceProvider?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    parentTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    parentTeamName?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    platformName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    refreshable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    richCaseNotifications: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    serviceProvider?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    skipThirdPartyManagedSourceUpdates: boolean;
    /**
     * 
     * @type {ControlSku}
     * @memberof ControlTeam
     */
    sku: ControlSku;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    skuEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    skuStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTeam
     */
    supportEmail?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlTeam
     */
    teamMembers?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    testMode: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlTeam
     */
    useChatOpsOnboardingGroup?: boolean;
}

/**
 * Check if a given object implements the ControlTeam interface.
 */
export function instanceOfControlTeam(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "autoSubscribeServiceProviderUsers" in value;
    isInstance = isInstance && "chatOpsAccountLockedMessage" in value;
    isInstance = isInstance && "chatOpsEscalationDelayMinutes" in value;
    isInstance = isInstance && "chatOpsSecondFactor" in value;
    isInstance = isInstance && "chatOpsSubjectLine" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "demo" in value;
    isInstance = isInstance && "emailSignature" in value;
    isInstance = isInstance && "endpointAutoContainment" in value;
    isInstance = isInstance && "escalationEmails" in value;
    isInstance = isInstance && "fileAutoContainment" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "identityAutoContainment" in value;
    isInstance = isInstance && "isTrial" in value;
    isInstance = isInstance && "logoUrl" in value;
    isInstance = isInstance && "managerChatOps" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "notificationEscalationSeverity" in value;
    isInstance = isInstance && "onboardingChecklistCompleted" in value;
    isInstance = isInstance && "refreshable" in value;
    isInstance = isInstance && "richCaseNotifications" in value;
    isInstance = isInstance && "skipThirdPartyManagedSourceUpdates" in value;
    isInstance = isInstance && "sku" in value;
    isInstance = isInstance && "testMode" in value;

    return isInstance;
}

export function ControlTeamFromJSON(json: any): ControlTeam {
    return ControlTeamFromJSONTyped(json, false);
}

export function ControlTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlTeam {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'autoSubscribeServiceProviderUsers': json['autoSubscribeServiceProviderUsers'],
        'billableEndpoints': !exists(json, 'billableEndpoints') ? undefined : json['billableEndpoints'],
        'billableUsers': !exists(json, 'billableUsers') ? undefined : json['billableUsers'],
        'billingEndpointLicenseId': !exists(json, 'billingEndpointLicenseId') ? undefined : json['billingEndpointLicenseId'],
        'billingUserLicenseId': !exists(json, 'billingUserLicenseId') ? undefined : json['billingUserLicenseId'],
        'chatOpsAccountLockedMessage': json['chatOpsAccountLockedMessage'],
        'chatOpsAccountLockedMessageInherited': !exists(json, 'chatOpsAccountLockedMessageInherited') ? undefined : json['chatOpsAccountLockedMessageInherited'],
        'chatOpsAllowBulkSmsInvite': !exists(json, 'chatOpsAllowBulkSmsInvite') ? undefined : json['chatOpsAllowBulkSmsInvite'],
        'chatOpsEscalationDelayMinutes': json['chatOpsEscalationDelayMinutes'],
        'chatOpsSecondFactor': json['chatOpsSecondFactor'],
        'chatOpsSubjectLine': json['chatOpsSubjectLine'],
        'chatOpsSubjectLineInherited': !exists(json, 'chatOpsSubjectLineInherited') ? undefined : json['chatOpsSubjectLineInherited'],
        'chatOpsWelcomeMessage': !exists(json, 'chatOpsWelcomeMessage') ? undefined : json['chatOpsWelcomeMessage'],
        'chatOpsWelcomeMessageInherited': !exists(json, 'chatOpsWelcomeMessageInherited') ? undefined : json['chatOpsWelcomeMessageInherited'],
        'createdAt': json['createdAt'],
        'demo': json['demo'],
        'emailSignature': json['emailSignature'],
        'emailSignatureInherited': !exists(json, 'emailSignatureInherited') ? undefined : json['emailSignatureInherited'],
        'endpointAutoContainment': json['endpointAutoContainment'],
        'escalationEmails': json['escalationEmails'],
        'escalationSubjectLine': !exists(json, 'escalationSubjectLine') ? undefined : json['escalationSubjectLine'],
        'fileAutoContainment': json['fileAutoContainment'],
        'id': json['id'],
        'identityAutoContainment': json['identityAutoContainment'],
        'isTrial': json['isTrial'],
        'logoUrl': json['logoUrl'],
        'managerChatOps': json['managerChatOps'],
        'maxAutoContainmentsPerDay': !exists(json, 'maxAutoContainmentsPerDay') ? undefined : json['maxAutoContainmentsPerDay'],
        'maxChatOpsPerDay': !exists(json, 'maxChatOpsPerDay') ? undefined : json['maxChatOpsPerDay'],
        'name': json['name'],
        'notificationEscalationSeverity': ControlNotificationEscalationSeverityFromJSON(json['notificationEscalationSeverity']),
        'onboardingChecklistCompleted': json['onboardingChecklistCompleted'],
        'operatingTeam': !exists(json, 'operatingTeam') ? undefined : json['operatingTeam'],
        'parentServiceProvider': !exists(json, 'parentServiceProvider') ? undefined : json['parentServiceProvider'],
        'parentTeamId': !exists(json, 'parentTeamId') ? undefined : json['parentTeamId'],
        'parentTeamName': !exists(json, 'parentTeamName') ? undefined : json['parentTeamName'],
        'platformName': !exists(json, 'platformName') ? undefined : json['platformName'],
        'refreshable': json['refreshable'],
        'richCaseNotifications': json['richCaseNotifications'],
        'serviceProvider': !exists(json, 'serviceProvider') ? undefined : json['serviceProvider'],
        'skipThirdPartyManagedSourceUpdates': json['skipThirdPartyManagedSourceUpdates'],
        'sku': ControlSkuFromJSON(json['sku']),
        'skuEndDate': !exists(json, 'skuEndDate') ? undefined : json['skuEndDate'],
        'skuStartDate': !exists(json, 'skuStartDate') ? undefined : json['skuStartDate'],
        'supportEmail': !exists(json, 'supportEmail') ? undefined : json['supportEmail'],
        'teamMembers': !exists(json, 'teamMembers') ? undefined : json['teamMembers'],
        'testMode': json['testMode'],
        'useChatOpsOnboardingGroup': !exists(json, 'useChatOpsOnboardingGroup') ? undefined : json['useChatOpsOnboardingGroup'],
    };
}

export function ControlTeamToJSON(value?: ControlTeam | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'autoSubscribeServiceProviderUsers': value.autoSubscribeServiceProviderUsers,
        'billableEndpoints': value.billableEndpoints,
        'billableUsers': value.billableUsers,
        'billingEndpointLicenseId': value.billingEndpointLicenseId,
        'billingUserLicenseId': value.billingUserLicenseId,
        'chatOpsAccountLockedMessage': value.chatOpsAccountLockedMessage,
        'chatOpsAccountLockedMessageInherited': value.chatOpsAccountLockedMessageInherited,
        'chatOpsAllowBulkSmsInvite': value.chatOpsAllowBulkSmsInvite,
        'chatOpsEscalationDelayMinutes': value.chatOpsEscalationDelayMinutes,
        'chatOpsSecondFactor': value.chatOpsSecondFactor,
        'chatOpsSubjectLine': value.chatOpsSubjectLine,
        'chatOpsSubjectLineInherited': value.chatOpsSubjectLineInherited,
        'chatOpsWelcomeMessage': value.chatOpsWelcomeMessage,
        'chatOpsWelcomeMessageInherited': value.chatOpsWelcomeMessageInherited,
        'createdAt': value.createdAt,
        'demo': value.demo,
        'emailSignature': value.emailSignature,
        'emailSignatureInherited': value.emailSignatureInherited,
        'endpointAutoContainment': value.endpointAutoContainment,
        'escalationEmails': value.escalationEmails,
        'escalationSubjectLine': value.escalationSubjectLine,
        'fileAutoContainment': value.fileAutoContainment,
        'id': value.id,
        'identityAutoContainment': value.identityAutoContainment,
        'isTrial': value.isTrial,
        'logoUrl': value.logoUrl,
        'managerChatOps': value.managerChatOps,
        'maxAutoContainmentsPerDay': value.maxAutoContainmentsPerDay,
        'maxChatOpsPerDay': value.maxChatOpsPerDay,
        'name': value.name,
        'notificationEscalationSeverity': ControlNotificationEscalationSeverityToJSON(value.notificationEscalationSeverity),
        'onboardingChecklistCompleted': value.onboardingChecklistCompleted,
        'operatingTeam': value.operatingTeam,
        'parentServiceProvider': value.parentServiceProvider,
        'parentTeamId': value.parentTeamId,
        'parentTeamName': value.parentTeamName,
        'platformName': value.platformName,
        'refreshable': value.refreshable,
        'richCaseNotifications': value.richCaseNotifications,
        'serviceProvider': value.serviceProvider,
        'skipThirdPartyManagedSourceUpdates': value.skipThirdPartyManagedSourceUpdates,
        'sku': ControlSkuToJSON(value.sku),
        'skuEndDate': value.skuEndDate,
        'skuStartDate': value.skuStartDate,
        'supportEmail': value.supportEmail,
        'teamMembers': value.teamMembers,
        'testMode': value.testMode,
        'useChatOpsOnboardingGroup': value.useChatOpsOnboardingGroup,
    };
}

